var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.727 11.1703L13.8297 8.27301M5.5 19.5L7.95137 19.2276C8.25087 19.1943 8.40062 19.1777 8.54059 19.1324C8.66477 19.0922 8.78295 19.0354 8.89191 18.9635C9.01473 18.8826 9.12127 18.776 9.33436 18.5629L18.9 8.99734C19.7 8.19727 19.7 6.90011 18.9 6.10005C18.0999 5.29998 16.8027 5.29998 16.0027 6.10005L6.43707 15.6656C6.22399 15.8787 6.11745 15.9853 6.03646 16.1081C5.9646 16.2171 5.9078 16.3352 5.8676 16.4594C5.82229 16.5994 5.80565 16.7491 5.77237 17.0486L5.5 19.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9c769666f16e2f6981188269a9ca2d41.svg";
export { ForwardRef as ReactComponent };